module.exports = __webpack_public_path__ + "img/avatar_default.8fde65ff.jpg";